module.exports = ".page-content {\r\n    margin-left: 21%;\r\n    margin-top: .5%;;\r\n}\r\n#editstationmap {\r\n    width: 950px;\r\n    height: 200px;\r\n}"